/**
 * Blocking (IIFE) bundle loaded by the Blade layouts in place of the old jQuery plugin scripts.
 * Views call these globals at parse time, so this must not be a deferred module.
 */
import { installGlobals } from './legacy-globals';

installGlobals(window);
